export default {
  root: {
    backgroundColor: '#07b2b7',
    backgroundImage: 'linear-gradient(#46c0a6, #07b2b7)',
  },
}
